// extracted by mini-css-extract-plugin
module.exports = {"overlay":"RegionModal_overlay__3eJvC","inputContainer":"RegionModal_inputContainer__rfGeq","feedback":"RegionModal_feedback__1aYbK","text":"RegionModal_text__Pkifk"};